<template>
    <base-dialog
      v-model="visible"
      title="Leave page"
      :buttons="buttons"
      @close="close"
    >
    <div class="leave-dialog">
    <div>Are you sure you want to leave this page?</div>
    <div>All unsaved changes will be lost.</div>
  </div>
    </base-dialog>

</template>

<script>
import BaseDialog from '@/components/dialogs/BaseDialog'

export default {
  name: 'SaveComparisonDialog',
  components: {
    BaseDialog,
  },
  props:{
    visible: {
        type: Boolean,
        default: false
      },
  },
  computed: {
    buttons() {
      return [
        {
          handler: this.close,
          label: 'Cancel',
          type: 'text',
        },
        {
          handler: this.leave,
          label: 'Leave',
          type: 'error',
        },
      ];
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    },
    leave() {
      this.$emit('handleLeavePage')
      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.leave-dialog {
display: flex;
flex-direction: column;
align-items: center;
gap: 4px;
}
::v-deep {
  .btn-delete {
    path {
      fill: white;
      stroke: var(--v-error-base);
    }
  }
}
</style>
